"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestLocalSport = exports.makeRequestLocalSport = exports.requestSport = exports.requestSportEventsByIds = void 0;
require("rxjs/add/operator/map");
require("rxjs/add/operator/switchMap");
require("rxjs/add/observable/of");
var Observable_1 = require("rxjs/Observable");
var core_1 = __importStar(require("@gin-betting/core"));
var constants_1 = require("./constants");
var actions_1 = require("./actions");
var selectors_1 = require("./selectors");
var getBettingOptions = core_1.default.utils.getBettingOptions;
var getHistory = core_1.default.services.getHistory;
var REHYDRATE = null;
try {
    // We should handle REHYDRATE action here for redux-persist@4 backward compatibility
    // this import will work only for v4
    REHYDRATE = require('redux-persist/constants').REHYDRATE;
}
catch (err) {
    // for redux-persist@6
    REHYDRATE = require('redux-persist').REHYDRATE;
}
var requestSportEventsByIds = function (actions$, state$) {
    return actions$
        .ofType(constants_1.GET_FAVORITE_EVENT_IDS_SUCCESS, constants_1.INIT_FAVORITE_LIST_LOCAL)
        .switchMap(function (action) {
        var data = action.payload.data;
        var favorite = data.favorite;
        var state = state$.getState();
        var matchesIds = selectors_1.selectMatchesByFavoriteIds(state).toArray();
        if (!favorite || favorite.length === 0 || matchesIds.length === 0)
            return Observable_1.Observable.empty();
        return Observable_1.Observable.of(actions_1.getFavoriteEventsByIds({
            sportEventIds: matchesIds,
            marketLimit: 3,
            isTopMarkets: true,
            withMarketsCount: true,
            marketStatuses: [
                core_1.GQL.MarketStatus.ACTIVE,
                core_1.GQL.MarketStatus.SUSPENDED,
            ],
        }, {
            listType: getHistory().location.pathname,
            isTopMarkets: true,
        }));
    });
};
exports.requestSportEventsByIds = requestSportEventsByIds;
var requestSport = function (actions$) {
    return actions$
        .ofType(constants_1.ADD_REHYDRATE_FAVORITE_MATCHES_SUCCESS)
        .map(function (action) {
        var requestFavoriteIdsVariables = action.payload.requestFavoriteIdsVariables;
        return actions_1.getFavoriteEventsIds(__assign({ matchStatuses: [
                core_1.GQL.SportEventStatus.LIVE,
                core_1.GQL.SportEventStatus.NOT_STARTED,
                core_1.GQL.SportEventStatus.SUSPENDED,
            ] }, requestFavoriteIdsVariables));
    });
};
exports.requestSport = requestSport;
var makeRequestLocalSport = function (requestFavoriteIdsVariables) {
    if (requestFavoriteIdsVariables === void 0) { requestFavoriteIdsVariables = {}; }
    return function (actions$, store) {
        if (!REHYDRATE)
            return actions$.switchMap(function (a) { return Observable_1.Observable.empty(); });
        return actions$.ofType(REHYDRATE).switchMap(function (action) {
            // --START hardcode for redux-persist@6
            var act = action;
            if (!act.payload)
                return Observable_1.Observable.empty();
            if (act.key && act.key === constants_1.NAME) {
                action.payload.favorite = act.payload;
            }
            // --END
            if (!action.payload.favorite)
                return Observable_1.Observable.empty();
            var incomeFavoriteIds = action.payload.favorite.favoriteIds;
            var isAuthorized = getBettingOptions().isAuthorized;
            var favoriteIds = store.getState().get('favorite').favoriteIds;
            var nextFavoriteIds = favoriteIds.merge(incomeFavoriteIds).toArray();
            if (isAuthorized) {
                return Observable_1.Observable.of(actions_1.addRehydrateMatchesToFavorite({ ids: nextFavoriteIds }, { requestFavoriteIdsVariables: requestFavoriteIdsVariables }));
            }
            return Observable_1.Observable.of(actions_1.initFavoriteLocal({ data: { favorite: nextFavoriteIds } }));
        });
    };
};
exports.makeRequestLocalSport = makeRequestLocalSport;
exports.requestLocalSport = exports.makeRequestLocalSport();
//# sourceMappingURL=epics.js.map